import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { redirect } from "@state";
import { DepositContext } from "@state/context/payment/DepositContext";
import { getCurrentCulture } from "@utils";
import { LimitSteps } from "@utils/limits/limitSteps";
import { observer } from "mobx-react";

export default observer(function DepositLimitCreditRating() {
	const depositStore = useContext(DepositContext);

	const { t } = useTranslation(["my-limits", "credit-rating"]);

	if (
		depositStore.depositLimitStore.activeStep !== LimitSteps.CREDIT_RATING
	) {
		return null;
	}

	return (
		<>
			<div className="popup__body">
				<InfoMessageComponent
					type="warning"
					message={t("credit-rating:DESCRIPTION")}
				/>
			</div>
			<div className="popup__footer">
				<button
					type="button"
					className="at-accVerifBtnSecondary popup__btn btn btn--med btn--primary--inverted"
					onClick={() => {
						redirect(
							`/${getCurrentCulture()}/account-settings/credit-rating`
						);
					}}
				>
					{t("COMMON.CONFIRM")}
				</button>
				{depositStore.depositLimitStore.limitData?.availableBudget !=
				null ? (
					<button
						type="button"
						className="at-accVerifBtnSecondary popup__btn btn btn--med btn--primary--inverted"
						onClick={() => {
							depositStore.depositLimitStore.deactivateDepositLimitPopup(
								true
							);
						}}
					>
						{t("PARTIAL_DEPOSIT")}
					</button>
				) : null}
			</div>
		</>
	);
});
